import React from 'react'
import {Field} from "react-final-form";

// resources
import { narrowDown } from '~/data/shop/itemSearchOption'

// components
import RenderRadioButton from '~/components/finalForms/atoms/RenderRadioButton'
import {useSelector} from "react-redux";
import Healthy from "../../templates/common/dialogs/Healthy";
import HealthyLarge from "../../templates/common/dialogs/HealthyLarge";
import Protein from "../../templates/common/dialogs/Protein";
import Care from "../../templates/common/dialogs/Care";


export const ItemCategoryField = React.memo(() => {

  const tooltip = [
    {
      code: 'healthy',
      component: Healthy,
    },{
      code: 'healthy_large',
      component: HealthyLarge,
    },{
      code: 'protein',
      component: Protein,
    },{
      code: 'care',
      component: Care,
    }
  ]

  // const tooltip = {
  //   healthy: { component: Healthy },
  //   healthy_large: { component: HealthyLarge },
  //   protein: { component: Protein },
  //   care: { component: Care }
  // }

  return(
      <div>
        <div>
          <Field
              id="itemCategory"
              name="itemCategory"
              labels={narrowDown.itemCategories.map((category) => category.label)}
              vals={narrowDown.itemCategories.map((category) => category.code)}
              component={RenderRadioButton}
              tooltip={tooltip}
              direction='column'
          />
        </div>
      </div>
  )
})
